import React, { createRef, memo, useCallback, useEffect } from 'react';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './Tabs.scss';
const rootClassName = 'component-tabs';

export interface TabsProps {
  tabs?: { title: string; id?: string; disabled?: boolean }[];
  justify?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  onChange: (val: number) => void;
  atual?: number | null;
  changeTitleColor?: boolean;
}

function Tabs(props: TabsProps) {
  const navRef = createRef<HTMLDivElement>();
  const actualRef = createRef<HTMLDivElement>();

  const startBar = useCallback(() => {
    const atual = navRef.current?.querySelector('.atual') as HTMLButtonElement;
    if (
      atual !== undefined &&
      atual !== null &&
      actualRef.current &&
      navRef.current
    ) {
      actualRef.current.style.opacity = '1';
      actualRef.current.style.left = `${
        atual.getBoundingClientRect().left -
        navRef.current.getBoundingClientRect().left
      }px`;
      actualRef.current.style.width = `${
        atual.getBoundingClientRect().width
      }px`;
    } else if (actualRef.current && navRef.current) {
      actualRef.current.style.opacity = '0';
    }
  }, [actualRef, navRef]);

  useEffect(() => {
    startBar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.atual]);

  useEffect(() => {
    window.addEventListener('resize', startBar);
    return () => {
      window.removeEventListener('resize', startBar);
    };
  }, [startBar]);

  return (
    <nav
      className={rootClassName}
      style={{ justifyContent: props.justify }}
      ref={navRef}
    >
      {props.tabs?.map((tab, index) => {
        return (
          <button
            className={getMergedClassNames([
              `${rootClassName}-tab`,
              props.atual === index ? 'atual' : '',
              props.atual && props.changeTitleColor ? 'change' : '',
            ])}
            onClick={() => {
              props.onChange(index);
            }}
            id={tab.id}
            key={tab.id || index}
            disabled={tab.disabled}
          >
            <span>{tab.title}</span>
          </button>
        );
      })}
      <div ref={actualRef} className={`${rootClassName}-bar`} />
    </nav>
  );
}

export default memo(Tabs);
